module.exports = "/images/logo-embursego.svg?629361958b54bf9839d2ff090707432e";